import React, { useEffect, useState } from 'react';
import { SearchFilterContainer } from './search-filter-container';
import { BATH_OPTIONS } from '../../util/listing-search.constants';
import { iconBath } from '../../util/icons';

export interface BathroomsProps {
  isOpen: boolean;
  bathrooms?: string;
  isFloating?: boolean;
  setSearchOption(key: string, value: string | number): void;
  open(): void;
  close(): void;
}

export const Bathrooms: React.FC<BathroomsProps> = props => {
  const [curLabel, setCurLabel] = useState('Bathrooms');

  const f = (
    <div className="form-field">
      <div className="form-field-label"><span className="icon">{iconBath}</span> Bathrooms</div>
      <div className="button-row">
        {BATH_OPTIONS.map((option, i) => <button key={i} className={props.bathrooms === option.value ? 'enabled' : ''} onClick={() => props.setSearchOption('bathrooms', option.value )}>{option.label}</button>)}
      </div>
    </div>
  );

  useEffect(() => {
    if (!props.bathrooms || props.bathrooms === 'all') {
      setCurLabel('Bathrooms');
    } else if (props.bathrooms.length === 1) {
      for (let option of BATH_OPTIONS) {
        for (let selectedOption of props.bathrooms) {
          if (option.value === selectedOption) {
            setCurLabel(option.label + ' Bath');
          }
        }
      }
    } else if (props.bathrooms.length > 1) {
      setCurLabel(props.bathrooms + ' Bath');
    }
  }, [props.bathrooms]);

  if (!props.isFloating) {
    return f;
  }

  return (
    <div>
      <button className={props.isOpen ? 'filter-button filter-button-selected' : props.bathrooms !== '' ? 'filter-button filter-button-enabled' : 'filter-button'} onClick={props.open}>{curLabel}</button>
      {props.isOpen &&
        <SearchFilterContainer close={props.close} alignRight>
          {f}
        </SearchFilterContainer>
      }
    </div>
  );
}
